// extracted by mini-css-extract-plugin
export default {"form-grid":"WidgetEdit_form-grid__7m9xp"};